// Handles the product form dynamic updates on form change
// Does not interact with Cart
import VariantSelectObserver from '../utilities/products/VariantSelectObserver';
import { currencyFormatter } from '../utilities/currency';

import { updateImages, initCurrentColor } from './product-form-images';
/* 1. get the DOM nodes */
const formEl = document.querySelector('.ProductForm');
const currColorEl = document.querySelector('[data-id="product-form-current-color"]');
const formBtn = document.querySelector('.ProductForm-submit');
const formBtnText = document.querySelector('[data-submit-button-text]');
const sizeInputs = document.querySelectorAll('[data-id="product-form-size-input"]');
const priceCurrEl = document.querySelector('[data-id="product-price-current"]');
const priceCompareEl = document.querySelector('[data-id="product-price-compare-at"]');
const quantityInput = document.querySelector('[data-id="product-form-quantity-select"]');
const variantIdInput = document.querySelector('[data-id="product-form-variant-id"]');
const valueOption = document.querySelector('[data-id="option-value"]');

const formBtnTextAdd = formBtnText && formBtnText.dataset.submitButtonText;
const formBtnTextSoldout = formBtnText && formBtnText.dataset.submitButtonTextSoldout;

/** 2. Subscriber functions, mostly handle DOM updates */
function updateUrl({ selectedVariant }) {
  const url = new URL(window.location);
  url.searchParams.set('variant', selectedVariant.id);
  window.history.replaceState(null, '', url.toString());
}

function handleSoldOutFormButton({ soldOutRelatedVariants, selectedVariant }) {
  const isCurrentSoldOut = soldOutRelatedVariants.some((variant) => {
    return variant.id === selectedVariant.id;
  });
  if (isCurrentSoldOut) {
    formBtn.disabled = 'disabled';
    if (formBtnTextAdd) formBtnText.textContent = formBtnTextSoldout;
  } else {
    formBtn.disabled = false;
    if (formBtnTextSoldout) formBtnText.textContent = formBtnTextAdd;
  }
}

function handleSoldOutOptions({ soldOutRelatedVariants }) {
  const options = soldOutRelatedVariants.map((variant) => variant.options[1]);
  sizeInputs.forEach((optEl) => {
    const el = optEl;
    if (options.includes(el.value)) {
      el.disabled = true;
    } else if (el.disabled) {
      el.disabled = false;
    }
  });
}

function updateVariantId({ selectedVariant }) {
  if (selectedVariant && formEl) {
    formEl.dataset.selectedVariant = selectedVariant.id;
    variantIdInput.value = selectedVariant.id;
  }
}

function updateColorText({ selectedVariant }) {
  if (selectedVariant && currColorEl) {
    const currColor = selectedVariant.options[0];
    currColorEl.textContent = currColor;
  }
}

function updateQuantityOptions({ selectedVariant, maxQuantity }) {
  const inventoryManagement = selectedVariant.inventory_management;
  if (!inventoryManagement) return;
  const quantity = selectedVariant.inventory_quantity;
  if (!quantity) return;
  let newOptions = '';
  /* eslint-disable-next-line no-plusplus */
  for (let i = 0; i < quantity; i++) {
    if (i === maxQuantity) break;
    newOptions += `<option value=${i + 1}>${i + 1}</option>`;
  }
  quantityInput.innerHTML = newOptions;
}

function updatePrice({ selectedVariant }) {
  const newPrice = selectedVariant.price;
  const newCompareAtPrice = selectedVariant.compare_at_price;

  if (window.Shopify === undefined) return;
  const priceText = currencyFormatter(
    newPrice,
    Shopify.locale,
    Shopify.country,
    Shopify.currency.active
  );
  if (priceCurrEl) priceCurrEl.textContent = priceText;
  if (newCompareAtPrice && newPrice !== newCompareAtPrice) {
    const priceCompareText = currencyFormatter(
      newCompareAtPrice,
      Shopify.locale,
      Shopify.country,
      Shopify.currency.active
    );
    if (priceCompareEl) priceCompareEl.textContent = priceCompareText;
  }
}

/** 3. Init the observer */

const variantSelector = new VariantSelectObserver(
  window.FormProductVariantData,
  window.FormProductDataFirstVariant,
  window.FormProductMaxQuantity
);

/** 4. Add the subscribers */
variantSelector.subscribe('load', handleSoldOutOptions);
variantSelector.subscribe('afterVariantUpdate', handleSoldOutOptions);
variantSelector.subscribe('load', handleSoldOutFormButton);
variantSelector.subscribe('afterVariantUpdate', handleSoldOutFormButton);
variantSelector.subscribe('afterVariantUpdate', updateVariantId);
variantSelector.subscribe('afterVariantUpdate', updateColorText);
variantSelector.subscribe('afterVariantUpdate', updateUrl);
variantSelector.subscribe('afterVariantUpdate', updateQuantityOptions);
variantSelector.subscribe('afterVariantUpdate', updatePrice);
variantSelector.subscribe('load', initCurrentColor);
variantSelector.subscribe('afterVariantUpdate', updateImages);

/** 6. run the load function to init the page */
variantSelector.load();

/** 7. Handle the event listener for option change */
function handleOptionChange(event) {
  const optionIndex = event.target.dataset.optionindex;
  if (!optionIndex) return;
  const { value } = event.target;
  variantSelector.updateVariantFromOptions(optionIndex, value);
}

formEl.querySelectorAll('input[type=radio]').forEach((radio) => {
  radio.addEventListener('change', handleOptionChange);
});

if (valueOption) valueOption.addEventListener('change', handleOptionChange);
